import React from 'react';
import PropTypes from 'prop-types';

import 'react-quill/dist/quill.snow.css'; // ES6
import ReactQuill from 'react-quill'; // ES6

import { AddIcon } from '../../../../images/icons/WrapSvg';

// eslint-disable-next-line
import EditorVariable from './EditorVarible';
// eslint-disable-next-line
import EditorName from './EditorName';
// eslint-disable-next-line
import IdAttribute from './IdAttribute';

import Dialog from './DialogFields';

const CustomToolbar = ({ onClickRaw }) => (
    <div id="toolbar">
        <span className="ql-formats">
            <select className="ql-header" defaultValue={''}>
                <option value="1" />
                <option value="2" />
                <option value="" />
            </select>
        </span>
        <span className="ql-formats">
            <select className="ql-color">
                <option value="red" />
                <option value="green" />
                <option value="blue" />
                <option value="orange" />
                <option value="violet" />
                <option value="#d0d1d2" />
                <option defaultValue />
            </select>
        </span>
        <span className="ql-formats">
            <button className="ql-bold" />
            <button className="ql-italic" />
            <button className="ql-underline" />
            <button className="ql-strike" />
            <button className="ql-blockquote" />
        </span>

        <span className="ql-formats">
            <button className="ql-list" value="ordered" />
            <button className="ql-list" value="bullet" />
            <button className="ql-indent" value="-1" />
            <button className="ql-indent" value="+1" />
            <button className="ql-clean" />
        </span>
        <button
            className="ql-button-add"
            onClick={onClickRaw}
        >
            <AddIcon className="c_white" />
        </button>
    </div>
);

const MinimunToolbar = ({ onClickRaw, text }) => (
    <div className="toolbar ql-toolbar ql-snow align_center">
        <button
            className="ql-button-add"
            onClick={onClickRaw}
        >
            <AddIcon className="c_white" />
        </button>
    </div>
);

class Editor extends React.Component {
    state = {
        value: undefined,
        theme: 'snow',
    };

    static getDerivedStateFromProps(props, state) {
        const { value, name } = props;
        if (state.name !== name || state.value !== value) {
            state.value = value;
            state.name = name;
            return state;
        }
        return null;
    }

    handleBlur = (range, source, quill) => {
        console.log(range, source, quill);
        this.setState({ range: range });
    };

    handleClickShowRaw = () => {
        console.log('Editor handleShowFields');
        this.setState({ open: true, range: this.subject.getEditor().getSelection() });
    };

    handleChange = (html, delta, source) => {
        if (source === 'user')
            this.props.onChange({ target: { name: this.props.name, value: html } });
    };

    handleClose = (item, type) => {
        if (item) {
            const index = this.state.range ? this.state.range.index : 0;
            const length = this.state.range ? this.state.range.length : 0;
            this.subject.getEditor().deleteText(index, length);
            this.subject
                .getEditor()
                .insertEmbed(
                    index,
                    type,
                    { value: item.nombre.toUpperCase(), id: item.codigo },
                    'user',
                );
        }
        this.setState({ open: undefined });
    };

    render() {
        const { open, theme, value } = this.state;
        return (
            <div className="boxBorder mb0">
                {this.props.min
                    ? <MinimunToolbar onClickRaw={this.handleClickShowRaw} />
                    : <CustomToolbar
                        onClickRaw={this.handleClickShowRaw}
                    />
                }

                {value !== undefined && (
                    <ReactQuill
                        ref={(el) => {
                            this.subject = el;
                        }}
                        theme={theme}
                        onChange={this.handleChange}
                        onBlur={this.handleBlur}
                        defaultValue={value}
                        modules={Editor.modules}
                        formats={Editor.formats}
                        bounds={'.app'}
                        placeholder={this.props.placeholder}
                    />
                )}
                {open && <Dialog {...this.props} onClose={this.handleClose} />}
            </div>
        );
    }
}

/*
 * Quill modules to attach to editor
 * See https://quilljs.com/docs/modules/ for complete options
 */
Editor.modules = {
    toolbar: {
        container: '#toolbar',
        handlers: {},
    },
    clipboard: {
        // toggle to add extra line breaks when pasting HTML:
        matchVisual: true,
    },
};

/*
 * Quill editor formats
 * See https://quilljs.com/docs/formats/
 */
Editor.formats = [
    'header',
    'font',
    'size',
    'value',
    'style',
    'bold',
    'italic',
    'underline',
    'strike',
    'blockquote',
    'list',
    'bullet',
    'indent',
    'color',
    'link',
    'image',
    'video',
    'variable',
    'nombre',
];

/*
 * PropType validation
 */
Editor.propTypes = {
    placeholder: PropTypes.string,
};

export default Editor;



// WEBPACK FOOTER //
// ./src/components/complex/manage/template/Editor.js